import { z } from "zod";
import { PaginationSchema } from "../../pagination/response/PaginationResponse";

const UserSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    email: z.string().email(),
    email_verified_at: z.string().nullable(),
    created_at: z.string(),
    updated_at: z.string(),
    channex_user_api_key: z.nullable(z.string()).optional(),
    username: z.nullable(z.string()).optional(),
    phone: z.string(),
});

export const LogSchema = z.object({
    id: z.number(),
    ip_address: z.nullable(z.string()),
    user_agent: z.nullable(z.string()),
    user_id: z.nullable(z.string().uuid()),
    action: z.string(),
    model_type: z.string(),
    // Not .uuid(): one non-UUID id (e.g. a future model with integer keys) would
    // fail validation for the whole page of logs.
    model_id: z.string(),
    log: z.string(),
    created_at: z.string(),
    updated_at: z.string(),
    property_id: z.nullable(z.string().uuid()).optional(),
    invoice_number: z.nullable(z.string()).optional(),
    voucher_number: z.nullable(z.string()).optional(),
    user: z.nullable(UserSchema).optional(),
    // Structured audit-trail fields (see AuditLogger) — nullish so this stays
    // compatible with rows written before these columns existed.
    old_value: z.record(z.any()).nullish(),
    new_value: z.record(z.any()).nullish(),
    context: z.record(z.any()).nullish(),
    correlation_id: z.nullable(z.string().uuid()).optional(),
});

export const LogResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number().int(),
    data: z.array(LogSchema),
    pagination: z.nullable(PaginationSchema).optional(),
});

export type LogResponse = z.infer<typeof LogResponseSchema>;
export type LogData = z.infer<typeof LogSchema>;
